import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { DeliveryMethods } from "@/shared/utils/enum";
import { useSetModal } from "@/shared/atoms/useModal";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import usePosOrderUser, {
  defaultPosOrderUser,
} from "@/shared/atoms/usePosOrderUser";

const useClientModalAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const [deliveryMethod] = usePosOrderDeliveryMethod();
  const setModal = useSetModal();
  const [orderUser, setOrderUser] = usePosOrderUser();
  const hasOrderUser = Object.values(orderUser || {}).some((user) => user);

  return {
    name: "clientModal" as CurrentActionTypes,
    label: t("posOrders.client"),
    set: () =>
      setModal("orderUser", {
        deliveryMethodId: deliveryMethod,
      }),
    deleteAction: () => setOrderUser(defaultPosOrderUser),
    hasDeleteAction: hasOrderUser,
    instantSet: true,
    filtered: false,
    disabled:
      deliveryMethod === DeliveryMethods.DINE_IN ||
      deliveryMethod === DeliveryMethods.POS_ORDER,
    iconVariant: "user",
    variant: "primary",
  };
};

const ClientModalAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useClientModalAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default ClientModalAction;
